/**
 * Opt-in content width for a runtime canvas. The canvas's `theme_config` (stored and returned
 * verbatim by the API) may carry `layout_width`: `"full"` removes the maximum width, a number
 * sets it in pixels (400 to 4000). Anything else, and a canvas without the key, keeps the
 * default of 900 px.
 */
export const DEFAULT_CANVAS_MAX_WIDTH = 900;
const MIN_WIDTH = 400;
const MAX_WIDTH = 4000;

export function canvasContentMaxWidth(themeConfig: unknown): number | "none" {
  if (
    !themeConfig ||
    typeof themeConfig !== "object" ||
    Array.isArray(themeConfig)
  ) {
    return DEFAULT_CANVAS_MAX_WIDTH;
  }
  const width = (themeConfig as Record<string, unknown>).layout_width;
  if (width === "full") return "none";
  if (typeof width === "number" && Number.isFinite(width) && width > 0) {
    return Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, Math.round(width)));
  }
  return DEFAULT_CANVAS_MAX_WIDTH;
}
